<script lang="ts">
  import { pageName } from '../stores/pageName';

  $pageName = 'Page Not Found';
</script>

<h1>Page not found</h1>

<style>
  h1 {
    text-align: center;
    margin-top: 80px;
  }
</style>
